<template>
  <div class="bar">
    <div
      class="progress"
      :class="{ loading }"
      :style="progressStyle"
    />
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    loading() {
      return this.progress < this.total;
    },
    progressStyle() {
      return {
        width: `${Math.ceil((this.progress / this.total) * 100)}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.bar {
  background: $white;
  padding: 2px;
  height: 14px;
}

.progress {
  background: #78a6dd;
  height: 100%;
  opacity: 1;
  transition:
    width 120ms ease-out,
    opacity 80ms ease-in;

  &.loading {
    opacity: 0.7;
  }
}
</style>
